export default {
  load_error_title: "文件載入失敗",
  load_error_subtitle: "抱歉，無法載入文件。請稍後再試。",
};
